import { render, staticRenderFns } from "./MyClassComponent.vue?vue&type=template&id=51a6f55f&"
import script from "./MyClassComponent.vue?vue&type=script&lang=js&"
export * from "./MyClassComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports